import { SET_REDIRECT_ROUTE, RESET_REDIRECT_ROUTE } from "./RouterActionTypes";

const actions = {
	[SET_REDIRECT_ROUTE]: ({ commit }, route) =>
	{
		commit(SET_REDIRECT_ROUTE, route);
	},
	[RESET_REDIRECT_ROUTE]: ({ commit }) =>
	{
		commit(SET_REDIRECT_ROUTE);
	},
};

export default { actions };